import React from 'react';
import { StepLabel as MuiStepLabel, StepLabelProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { capitalize } from '@mui/material/utils';
import StepIcon from './StepIcon';

const useStyles = makeStyles<void, 'label' | 'completed' | 'active' | 'alternativeLabel'>()(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (theme, _params, classes) => ({
    active: {},
    disabled: {},
    completed: {},
    alternativeLabel: {},
    root: {
      '&.colorWhite': {
        [`& .${classes.label}`]: {
          color: theme.palette.custom.white,
          'button:hover &': {
            color: theme.palette.custom.white,
          },
        },
        [`& .${classes.label}.${classes.completed}`]: {
          color: '#D1DFFF',
          'button:hover &': {
            color: '#D1DFFF',
          },
        },
      },
      '&.colorDefault': {
        [`& .${classes.label}`]: {
          color: theme.palette.primary.main,
        },
        [`& .${classes.label}.${classes.active}, & .${classes.label}.${classes.completed}`]: {
          color: theme.palette.primary.main,
          fontWeight: theme.typography.fontWeightMediumBold,
        },
      },
    },
    label: {
      ...theme.typography.caption,
      fontWeight: theme.typography.fontWeightMediumBold,
      [`&.${classes.alternativeLabel}`]: {
        marginTop: 8,
      },
    },
    iconContainer: {
      zIndex: 1,
    },
  }),
);

const StepLabel: React.FC<React.PropsWithChildren<StepLabelProps & { muiName?: string; disabled?: boolean }>> = ({
  className,
  StepIconComponent = StepIcon,
  StepIconProps,
  color = 'default',
  disabled = false,
  ...props
}) => {
  const { classes, cx } = useStyles();
  return (
    <MuiStepLabel
      {...props}
      className={cx(`color${capitalize(color)}`, className)}
      classes={classes}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      StepIconComponent={StepIconComponent}
      StepIconProps={{
        ...StepIconProps,
        disabled,
        color,
      }}
    />
  );
};

// TODO:
// StepLabel.muiName = 'StepLabel';

export default StepLabel;
